var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.69 17s-1.218-2.449-1.397-2.917A1.681 1.681 0 0019.569 13H18v-.956a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V13h-1.569a1.68 1.68 0 00-1.724 1.083C10.527 14.55 9.31 17 9.31 17A1.735 1.735 0 008 18.698V23h1v.8a1.234 1.234 0 002.467 0V23h9.066v.8a1.234 1.234 0 002.467 0V23h1v-4.302A1.738 1.738 0 0022.69 17zm-10.823-2.481a.75.75 0 01.506-.519h7.254a.754.754 0 01.506.519l1.1 2.481H10.764l1.102-2.481zm-1.25 6.352a1.082 1.082 0 01-1.099-1.053 1.107 1.107 0 011.1-1.083 1.082 1.082 0 011.07 1.083 1.057 1.057 0 01-1.06 1.053zm10.766 0a1.057 1.057 0 01-1.07-1.043v-.01a1.07 1.07 0 012.14-.025v.025a1.058 1.058 0 01-1.064 1.053zM13.066 6.747h-1.104v3.538h-.858V6.747H10v-.755h3.066zm3.629 3.416v.122h-.865l-.25-.883h-1.412l-.25.883h-.823v-.122l1.33-4.17h.945zm-1.331-1.509l-.472-1.674h-.037l-.472 1.674zm5.07 1.502v.129h-.901l-.736-1.46h-.074l-.785 1.46h-.872v-.128l1.204-2.012-1.172-2.03v-.123h.907l.718 1.393h.073l.742-1.392h.865v.122l-1.165 1.968zm.708-4.164H22v4.293h-.858z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--taxi-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TaxiCircleIcon';
export default Icon;